import { render, staticRenderFns } from "./TransferenciaLocDetalleComponent.vue?vue&type=template&id=3b70228c&"
import script from "./TransferenciaLocDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./TransferenciaLocDetalleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports